// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"9b6834f9","231":"13298b06","310":"a3656166","512":"e9c0da9a","514":"8b7c95c4"}[chunkId] + ".chunk.js";
};